import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useCluster } from '@cast/shared-cluster-context-data-access';
import { OptimizationWorkload } from '@cast/types';

const WORKLOADS_QUERY_KEY = 'inventory-workloads';

export const getWorkloadsQueryKey = (clusterId: string) => [
  WORKLOADS_QUERY_KEY,
  clusterId,
];

const getWorkloadsQueryOptions = ({
  clusterId,
  enabled,
}: {
  clusterId: string;
  enabled?: boolean;
}) =>
  queryOptions<OptimizationWorkload[]>({
    queryKey: getWorkloadsQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.workloadOptimization.getWorkloads(
        {
          clusterId,
        },
        {
          timeout: 60_000,
        }
      );
      return data.workloads || [];
    },
    enabled,
  });

type UseWorkloadsArgs = {
  enabled?: boolean;
};

export const useWorkloads = ({ enabled = true }: UseWorkloadsArgs = {}) => {
  const { cluster } = useCluster();

  const { isLoading, isFetching, data, error, refetch } = useQuery(
    getWorkloadsQueryOptions({ clusterId: cluster.id, enabled })
  );

  return {
    workloads: data,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};
